import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, Segment } from "../..";
import "./style.css";

/**
 * Toggle du framework 360.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Toggle = function Toggle(_ref) {
  var children = _ref.children,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label;
  var _React$useState = React.useState(0),
    selectedPosition = _React$useState[0],
    setSelectedPosition = _React$useState[1];
  React.useEffect(function () {
    React.Children.forEach(children, function (child, index) {
      var _child$props;
      if ((_child$props = child.props) != null && _child$props.active) {
        setSelectedPosition(index);
      }
    });
  }, [children]);
  var handleClick = function handleClick(e, data, element) {
    var _element$props;
    if (disabled) {
      return;
    }
    var position = data.position;
    setSelectedPosition(position);
    if (onChange) {
      onChange(position);
    }
    if ((_element$props = element.props) != null && _element$props.onClick) {
      element.props.onClick(e, data);
    }
  };
  var getActivePosition = function getActivePosition() {
    return selectedPosition * 100 / children.length;
  };
  var getChildren = function getChildren() {
    var position = -1;
    return React.Children.map(children, function (child) {
      position += 1;
      return /*#__PURE__*/React.cloneElement(child, {
        position: position,
        active: position === selectedPosition,
        className: position === selectedPosition ? 'selected' : '',
        onClick: function onClick(e, data) {
          handleClick(e, data, child);
        }
      });
    });
  };
  var renderToggle = function renderToggle() {
    return /*#__PURE__*/_jsxs(Button.Group, {
      as: Segment,
      className: "toggle " + (fluid ? 'fluid' : ''),
      inverted: true,
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(Segment, {
        className: "selection",
        inverted: true,
        style: {
          left: getActivePosition() + "%"
        }
      }), getChildren()]
    });
  };
  renderToggle.handledProps = [];
  if (_.isNil(label)) {
    return renderToggle();
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "field",
    children: [/*#__PURE__*/_jsx("label", {
      children: label
    }), " ", renderToggle()]
  });
};
Toggle.handledProps = ["children", "disabled", "fluid", "label", "onChange"];
Toggle.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func,
  fluid: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string
};
Toggle.defaultProps = {
  children: null,
  onChange: null,
  fluid: false,
  disabled: false,
  label: null
};
export default Toggle;